import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import ArtistForm from "../components/ArtistForm";
import Footer from "../components/Footer";

const ArtistInfoPage = () => {
  return (
    <div className="min-h-screen bg-black relative">
      <Navbar />
      <main>
        <Hero />
        <section className="relative z-10 max-w-5xl mx-auto px-5 sm:px-8 mb-14">
          <div className="hss-card p-7 sm:p-9">
            <p className="font-serif-body text-white/60 text-[1.02rem] leading-relaxed">
              For many questions, shorter answers work best. Think of them as memorable facts or stories that
              could appear on screen while your music is playing. Don't worry about saying the "right" thing.
              We're looking for what makes your journey different from everyone else's.
            </p>
            <p className="font-serif-body font-semibold text-white text-[1.02rem] mt-4">
              Thank you for being part of First Season. We can't wait to share your story.
            </p>
          </div>
        </section>
        <section className="relative z-10 pb-8">
          <ArtistForm />
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ArtistInfoPage;
